import React from 'react';

import session from 'services/sessionService';
import Card from 'components/fullWidthCard';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class Accounts extends React.PureComponent {
  static displayName = 'Accounts';

  static propTypes = {
    intl: intlShape.isRequired,
  };

  render() {
    let level = session.getUser().privileges.level;
    let {formatMessage} = this.props.intl;
    const width = '100%';

    return <div className='container scanner-tools'>
      <Card title={formatMessage({id: 'tools.inactive.customers.accounts'})}
            link='#tools/accounts/inactive'
            right={<a className='btn btn-primary pull-right'
                      style={{width}}
                      href='#tools/accounts/inactive'><FormattedMessage id="tools.inactive.customers"/></a>}
            body={formatMessage({id: 'tools.inactive.customers.description'})}/>

      {level >= 3000 ? <Card title={formatMessage({id: 'tools.update.product.profile'})}
                             link='#tools/accounts/product-update'
                             right={<a className='btn btn-primary pull-right download-package'
                                       href='#tools/accounts/product-update'
                                       style={{width}}><FormattedMessage id="tools.update.product.profile"/></a>}
                             body={formatMessage({id: 'tools.update.product.description'})}/> : null}

      {level >= 2000 ? <Card
        title={formatMessage({id: 'tools.merge.duplicate.accounts'})}
        link='#tools/accounts/merge/0'
        body={formatMessage({id: 'tools.merge.duplicate.description'})}
        right={<a className='btn btn-primary pull-right'
                  href='#tools/accounts/merge/0'
                  style={{width}}><FormattedMessage id="tools.find.duplicates"/></a>}/> : null}

      {level >= 2000 ? <Card
        title={formatMessage({id: 'tools.split.contact.two'})}
        link='#tools/accounts/split-contacts/0'
        body={formatMessage({id: 'tools.split.contact.description'})}
        right={<a className='btn btn-primary pull-right'
                  href='#tools/accounts/split-contacts/0'
                  style={{width}}><FormattedMessage id="tools.find.contacts"/></a>}/> : null}

      {level >= 2000 ? <Card
        title={formatMessage({id: 'tools.find.replace.data'})}
        link='#tools/accounts/find-replace/0'
        body={formatMessage({id: 'tools.find.replace.description'})}
        right={<a className='btn btn-primary pull-right'
                  href='#tools/accounts/find-replace/0'
                  style={{width}}><FormattedMessage id="tools.find.replace.button"/></a>}/> : null}

      <Card
        title={formatMessage({id: 'tools.verify.account.title'})}
        link='#tools/accounts/verify-addresses/0'
        body={formatMessage({id: 'tools.verify.account.description'})}
        right={<a className='btn btn-primary pull-right'
                  href='#tools/accounts/verify-addresses/0'
                  style={{width}}><FormattedMessage id="tools.verify.account.button"/></a>}/>

      <Card
        title={formatMessage({id: 'tools.find.multiple.systems'})}
        link='#tools/accounts/multiple-systems/0'
        body={formatMessage({id: 'tools.find.multiple.description'})}
        right={<a className='btn btn-primary pull-right'
                  href='#tools/accounts/multiple-systems/0'
                  style={{width}}><FormattedMessage id="tools.find.multiple.button"/></a>}/>
    </div>;
  }
}

export default injectIntl(Accounts);
